import React from 'react';
import styled from 'styled-components';
import Searchbar from './Searchbar';
import ManageUsersContext from '../ManageUsersContext';
import { StyledHeaderActions } from '../StyledComponents';

const DeletedHeader: React.FC<{ md: boolean }> = ({ md }) => {
  const { searchText, setSearchText } = React.useContext(ManageUsersContext);

  return (
    <StyledHeaderActions wrap $md={md}>
      <StyledSearchbar
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
        data-cy="deleted-search-input"
      />
    </StyledHeaderActions>
  );
};

const StyledSearchbar = styled(Searchbar)`
  margin-right: 8px;
`;

export default DeletedHeader;
